module.exports = __webpack_public_path__ + "static/media/CulturePhoto2.35b38c75.jpg";